export default __webpack_public_path__ + "img/vokoZJjd.7bd29c41.svg";